var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content animate-panel" }, [
    _vm.dashboardIframeUrl
      ? _c("div", { staticClass: "box-dashboard-iframe" }, [
          _c("iframe", {
            attrs: {
              id: "dashboard-iframe",
              src: _vm.dashboardIframeUrl,
              width: "100%",
              height: "",
              frameborder: "0",
              allowTransparency: "true"
            }
          })
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-07c1511d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07c1511d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/Analysis.vue
// module id = null
// module chunks = 